import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { isUndefined } from 'lodash-es';
import { Controller, useWatch, useFormContext } from 'react-hook-form';
import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { buildMakeYearModelsPath, VehicleModel } from 'client/data/models/vehicle-v2';
import { PUB_STATES } from 'client/constants/pub-states';
import { TrackingHandler } from 'client/tracking/handler';
import { Select } from 'site-modules/lease-deals/components/deals-checker-widget/ui/select/select';
import { DEAL_CHECKER_CREATIVE_ID } from 'site-modules/lease-deals/components/deals-checker-widget/constants';
import { TrackingConstant } from 'client/tracking/constant';

const LEASE_PUB_STATES = [PUB_STATES.NEW, PUB_STATES.NEW_USED];

function ModelSelectorUI({ models = undefined, make = undefined, year = undefined }) {
  const { control, setValue } = useFormContext();
  const options = (models || []).map(m => ({ value: m.niceId, label: m.name }));

  const handleModelChange = useCallback(
    (value, label) => {
      setValue('model', value, { shouldValidate: true });
      setValue('modelName', label, { shouldValidate: true });
      TrackingHandler.fireEvent('deal_checker_model_select', {
        event_data: {
          value: label,
          creative_id: DEAL_CHECKER_CREATIVE_ID,
          action_cause: TrackingConstant.SELECT_CHANGE,
        },
      });
    },
    [setValue]
  );

  return (
    <Controller
      name="model"
      control={control}
      rules={{ required: true }}

      render={({ field: { ref, ...restField } }) => (
        <Select
          {...restField}
          onChange={handleModelChange}
          options={options}
          labelText="Model"
          toggle="Select model"
          disabled={!make || !year}
          isLoading={!!make && !!year && isUndefined(models)}
        />
      )}
    />
  );
}

ModelSelectorUI.propTypes = {
  make: PropTypes.string,
  year: PropTypes.string,
  models: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string, niceId: PropTypes.string })),
};

const ModelSelectorConnected = connectToModel(ModelSelectorUI, {
  models: bindToPath(
    ({ make, year }) => make && year && buildMakeYearModelsPath(make, year, LEASE_PUB_STATES),
    VehicleModel
  ),
});

export function ModelSelector() {
  const make = useWatch({ name: 'make' });
  const year = useWatch({ name: 'year' });

  return <ModelSelectorConnected make={make} year={year} />;
}
